import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { useRouter } from './useRouter';
import { useGetStructureDataQuery } from '@/__generated__/graphql';
import { selectedPlatformId as selectedPlatformIdState } from '@/state';
import { useGetStructureId } from './useGetStructureId';

export const useGetPlatformId = (): string | undefined => {
  const platformIdState = useAtomValue(selectedPlatformIdState);
  const router = useRouter();
  const { platformId } = router?.query || {};
  const structureId = useGetStructureId();

  const platformIdFromQuery = useMemo(() => {
    if (!platformId) {
      return undefined;
    }
    return Array.isArray(platformId) ? platformId[0] : platformId;
  }, [platformId]);

  const hasPlatformFromRouterOrState = Boolean(platformIdState) || Boolean(platformIdFromQuery);

  const { data: structureData } = useGetStructureDataQuery({
    variables: { structureId },
    skip: !structureId || hasPlatformFromRouterOrState,
    fetchPolicy: 'cache-first',
  });

  const selectedPlatformId = useMemo(() => {
    if (platformIdState) {
      return platformIdState;
    }
    if (platformIdFromQuery) {
      return platformIdFromQuery;
    }
    const platformIdFromStructure = structureData?.structure?.platform?.id;
    if (platformIdFromStructure) {
      return platformIdFromStructure;
    }
    return '';
  }, [platformIdFromQuery, platformIdState, structureData?.structure?.platform?.id]);

  return selectedPlatformId;
};
